
import { requester } from "App";
import { textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import style from "./PartnersVendingRegister.module.css";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import useLocalStorage from "shared/hooks/useLocalStorage";
import { getTokenPayload, validateInputs } from "shared/utils/Utils";
import { CFormSelect } from "@coreui/react";

function PartnersVendingRegister() {
    const inputs = useRef([]);
    const searchRef = useRef();
    const selectRef = useRef();
    const { t } = useTranslation();
    const [duplicateCheck, setDuplicateCheck] = useState(true);
    const id = 'root';
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);
    const { userId, userName } = useContext(AuthContext);
    const [searchResults, setSearchResults] = useState();
    const [machineType, setMachineType] = useState("");
    const [selectedVendorId, setSelectedVendorId] = useState();
    const [token, setToken] = useLocalStorage("token");

    const payload = getTokenPayload(token);

    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        let data = { userName: payload.userName }
        requester.findByVendorName(data, (result) => {
            setSearchResults(result.data)
            setSelectedVendorId(result.data.id)
        })

    }, [isMounted])

    const handleSelectMachineTypeChange = (event) => {
        setMachineType(event.target.value);
    };

    const onClick = () => {
        let data = { vendorId: selectedVendorId, vendingName: '', machineType:machineType === "" ? null : machineType}

        if (selectedVendorId) {
            validateInputs(inputs.current).then((result) => {
                if (result.isValid) {
                    data.vendingName = inputs.current[0].getValue();
                    requester.createVending(data, (result) => {
                        if (result.data) {
                            toast.success((`${data.vendingName} 등록에 성공했습니다.`), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                    })
                } else {
                    toast.error(t("pleaseCheck"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            });

        }
        else {
            toast.error(t("pleaseCheck"), {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }
    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    return (
        <Container>
            <div className={style.section}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} maxWidth={"100px"} >
                                <P>기기 이름</P>
                            </FlexChild>
                            <FlexChild maxWidth={"400px"}>
                                <InputText ref={el => (inputs.current[0] = el)} regExp={[textFormat]} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} maxWidth={"100px"}>
                                <P>기기 유형</P>
                            </FlexChild>
                            <FlexChild maxWidth={"400px"}>
                                <CFormSelect onChange={handleSelectMachineTypeChange}>
                                    <option value={""}>선택하세요</option>
                                    <option key={"KIOSK"} value={"KIOSK"}>
                                        {"키오스크"}
                                    </option>
                                    <option key={"SPRING"} value={"SPRING"}>
                                        {"스프링 자판기"}
                                    </option>
                                    <option key={"HOLDER"} value={"HOLDER"}>
                                        {"홀더 자판기"}
                                    </option>
                                </CFormSelect>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} maxWidth={"100px"}>
                            <P>파트너 ID </P>
                            </FlexChild>
                            <FlexChild maxWidth={"400px"}>
                            <FlexChild>
                                        <InputText ref={searchRef} placeHolder={"점주 ID"} value={searchResults?.userName} readOnly />
                                    </FlexChild>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <CustomButton text={"기기등록"} style={btnStyle} onClick={onClick} />
                    </FlexChild>
                </VerticalFlex>
            </div>
        </Container>
    );
}

export default PartnersVendingRegister;